/* eslint-disable @typescript-eslint/no-deprecated */
import { Icon, Tag } from '~/components';
import { Label } from '~/components/Label';
import { TruncateWithTooltip } from '~settings/components/TruncateWithTooltip';
import { MAX_TAG_CHARACTERS } from '~settings/constants';

interface AppliedFilterProps {
  filterTitle: string;
  label: string;
  value: string;
  queryParam: string;
  onRemove: (key: string, value: string) => void;
}

function AppliedFilter(params: AppliedFilterProps) {
  const { filterTitle, label, value, queryParam, onRemove } = params;

  return (
    <Tag
      variant="secondary"
      size="lg"
      role="group"
      asChild
      data-testid="applied-filter-chip"
    >
      <li className="whitespace-nowrap">
        <Label disabled={true} asSpan>
          {filterTitle}:
        </Label>
        <TruncateWithTooltip
          maxCharacters={MAX_TAG_CHARACTERS}
          className="inline-block"
        >
          <Label asSpan>{label}</Label>
        </TruncateWithTooltip>

        <button
          onClick={() => onRemove(queryParam, value)}
          aria-label={`Remove ${label} filter`}
        >
          <Icon
            type="circle-xmark"
            variant="regular"
            size="md"
            className="pl-xs"
          />
        </button>
      </li>
    </Tag>
  );
}

AppliedFilter.displayName = 'AppliedFilter';
export { AppliedFilter };
